import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Menu = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Menu' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M2,19 L22,19 M2,5 L22,5 M2,12 L22,12' />
  </StyledIcon>
);
